import { AxiosInstance } from 'axios'
import { Localizations, MediaObject } from '../types'

export interface GetSearchSpecialistsArgs {
  locale: string
}
type SpecialtiesDto = {
  attributes: {
    name: string
  }
}
export type Specialist = {
  attributes: {
    localizations: Localizations
    name: string
    slug: string
    photo: MediaObject | null
    specialties: {
      data: SpecialtiesDto[]
    }
  }
}

export const getSearchSpecialists = async (client: AxiosInstance, { locale }: GetSearchSpecialistsArgs) => {
  const specsPath = `/specialists`
  const specsParams = {
    locale,
    fields: ['name', 'slug'],
    populate: {
      localizations: {
        fields: ['locale', 'slug'],
      },
      photo: {
        populate: '*',
      },
      specialties: {
        fields: ['name'],
      },
    },
    // pagination: {
    //   start: 0,
    //   limit: Infinity,
    // },
  }

  return (
    await client.get<{
      data: Specialist[]
    }>(specsPath, { params: specsParams })
  ).data.data
}
